export enum AddressType {
  Home = 'Home',
  Shipping = 'Shipping',
  Billing = 'Billing',
}
